import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// Modules

// App
import Error from "../../../partials/error";
import { getOnlineNode } from "../../../core/getNode";
import { apiEndpoints } from "../../../config";
import { alertMessages } from "../../../partials/alertMessages";

// UI components
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LatestItem from "./latestItem";
import { Typography } from "@mui/material";
import LoadingSpinner from "../../../partials/loadingSpinner";

const pageSize = 24;

export default function Home(props) {
  const [isLoading, setLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [feed, setFeed] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(null);
  const [isFetchingMore, setFetchingMore] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [welcomeText, setWelcomeText] = useState("");

  const user = useSelector((state) => state).authReducer.user;
  const isPublic = props.isPublic || false;


  useEffect(() => {
    if (!isPublic) {
      getUser();
    }

    // eslint-disable-next-line
  }, [isPublic]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [currentPage]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 100 &&
        !isFetchingMore
      ) {
        loadMore();
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line
  }, [isFetchingMore]);

  const loadMore = () => {
    if (!isFetchingMore) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  /**
   * @function setError
   * @description Updates the state of the component upon an error
   * @param {boolean} _isError
   * @param {int} _errorStatus
   * @param {string} _errorMessage
   */
  const _setError = (_isError, _errorStatus, _errorMessage) => {
    setLoading(false);

    setIsError(_isError);
    setErrorStatus(_errorStatus);
    setErrorMessage(_errorMessage);
  };

  const getUser = () => {
    if (!isPublic) {
      getOnlineNode('api/v2/users?uid=' + user.current_user.uid)
      .then((response) => {
        setUserDetails(response.data.rows[0]);
      })
      .catch((_error) => {
        if (_error.response) {
          _setError(true, _error.response.status, _error.response.statusText);
        } else if (_error.request) {
          _setError(true, 0, alertMessages.requestError.message);
        } else {
          _setError(true, 0, alertMessages.unkownError.message);
        }
      });
    }
  };

  const getData = () => {
    // prevent overload and overfetch
    if (isFetchingMore || (totalPages && currentPage >= totalPages)) return;

    setFetchingMore(currentPage > 0);

    getOnlineNode(
      `${apiEndpoints.home2}?items_per_page=${pageSize}&page=${currentPage}&isPublic=${isPublic}`
    )
      .then((response) => {
        setFeed((prevData) => [...prevData, ...response.data.rows]);
        setWelcomeText(response.data.welcome_text);
        setTotalPages(response.data.pager.total_pages);
      })
      .finally(() => {
        setLoading(false);
        setFetchingMore(false);
      });
  };

  const renderGreeting = () => {
    if (user) {
      return (
        <>
          <Row className="gx-0 mb-3">
            <Col xs={"auto"} className="me-2">
              <Typography
                variant="h1"
                owner={"client"}
                weight="medium"
                color="clientText.dark"
              >
                Hello,
              </Typography>
            </Col>
            <Col xs={"auto"}>
              <Typography
                variant="h1"
                owner={"client"}
                weight="medium"
                color="clientPrimary.main"
              >
                {userDetails?.field_first_name
                  ? userDetails?.field_first_name
                  : userDetails?.name}
              </Typography>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <div dangerouslySetInnerHTML={{ __html: welcomeText }} />
            </Col>
          </Row>
        </>
      );
    }
  };

  const renderLatest = () => {
    if (feed && feed.length > 0) {
      return (
        <>
          <Row className="mb-3 gx-0">
            <Typography
              className="latest-header section-header pb-2"
              variant="h1"
              owner={"client"}
              weight="medium"
              color="clientText.dark"
            >
              Latest
            </Typography>
          </Row>
          <Row>
            {feed.map((item, index) => (
              <LatestItem key={`latest-${item.id}-${index}`} item={item} isPublic={isPublic} />
            ))}
          </Row>
        </>
      );
    }
  };

  if (isError) {
    return <Error status={errorStatus} message={errorMessage} />;
  } else {
    return (
      <main className="home screen">
        <Row className="mt-4 justify-content-center">
          <Col
            className="feed-column py-5 px-3 px-sm-4 position-relative"
            xs={12}
            sm={10}
            md={8}
            lg={7}
            xl={8}
            xxl={11}
          >
            {renderGreeting()}
            {feed && feed.length > 0 && renderLatest()}
            {(isFetchingMore || isLoading) && (
              <Row>
                <Col xs={12}>
                  <LoadingSpinner />
                </Col>
              </Row>
            )}
            {/* {renderFeatured()} */}
          </Col>
          {/* {renderTwitterTimeline()} */}
        </Row>
      </main>
    );
  }
}
